(() => {
  'use strict';

  const important = (
    element,
    property,
    value
  ) => {
    element.style.setProperty(
      property,
      value,
      'important'
    );
  };

  function showCopyMessage() {
    let message = document.getElementById(
      'sacha-copy-confirmation'
    );

    if (!message) {
      message = document.createElement('div');
      message.id = 'sacha-copy-confirmation';
      document.body.appendChild(message);
    }

    message.textContent =
      'Voucher code copied';

    message.style.cssText = `
      background:#111;
      border-radius:30px;
      bottom:110px;
      color:#fff;
      font-family:inherit;
      font-size:13px;
      font-weight:600;
      left:50%;
      padding:11px 18px;
      position:fixed;
      transform:translateX(-50%);
      white-space:nowrap;
      z-index:2147483647;
    `;

    window.clearTimeout(
      window.sachaCopyMessageTimer
    );

    window.sachaCopyMessageTimer =
      window.setTimeout(() => {
        message.remove();
      }, 1600);
  }

  document.addEventListener(
    'click',
    (event) => {
      const button =
        event.target.closest?.(
          '.sacha-rh-code [data-copy-code]'
        );

      if (!button) return;

      const row = button.closest(
        '.sacha-rh-voucher'
      );

      if (
        row?.querySelector(
  '.sacha-rh-status--expired, .sacha-rh-status--redeemed'
        )
      ) {
        return;
      }

      window.setTimeout(
        showCopyMessage,
        50
      );
    }
  );

  function fixCopyIcons() {
    document
      .querySelectorAll(
        '.sacha-rh-voucher'
      )
      .forEach((row) => {
        const cell = row.querySelector(
          '.sacha-rh-code'
        );

        const status = row.querySelector(
          '.sacha-rh-status'
        );

        if (!cell) return;

        let button = cell.querySelector(
          '[data-copy-code]'
        );

        if (!button) return;

const unavailable =
  status?.classList.contains(
    'sacha-rh-status--expired'
  ) ||
  status?.classList.contains(
    'sacha-rh-status--redeemed'
  ) ||
  /^(expired|redeemed)$/i.test(
    status?.textContent.trim() || ''
  );

if (unavailable) {
          important(
            button,
            'display',
            'none'
          );

          button.hidden = true;
          return;
        }

        button.hidden = false;

        if (
          !window.matchMedia(
            '(max-width: 749px)'
          ).matches
        ) {
          return;
        }

        if (
          cell.dataset.copyInlineFixed ===
            'true'
        ) {
          return;
        }

        const code = cell.querySelector(
          ':scope > span'
        );

        button = cell.querySelector(
          ':scope > button[data-copy-code]'
        );

        if (!code || !button) return;

        cell.dataset.copyInlineFixed =
          'true';

        const line =
          document.createElement('div');

        line.className =
          'sacha-rh-copy-line';

        cell.insertBefore(line, code);
        line.append(code, button);

        important(
          cell,
          'display',
          'block'
        );

        important(
          cell,
          'overflow',
          'visible'
        );

        important(
          cell,
          'position',
          'relative'
        );

        important(
          cell,
          'text-align',
          'left'
        );

        important(
          cell,
          'width',
          'auto'
        );

        important(
          line,
          'align-items',
          'center'
        );

        important(
          line,
          'display',
          'inline-flex'
        );

        important(
          line,
          'flex',
          '0 0 auto'
        );

        important(
          line,
          'flex-direction',
          'row'
        );

        important(
          line,
          'flex-wrap',
          'nowrap'
        );

        important(
          line,
          'gap',
          '7px'
        );

        important(
          line,
          'justify-content',
          'flex-start'
        );

        important(
          line,
          'margin',
          '0'
        );

        important(
          line,
          'max-width',
          'max-content'
        );

        important(
          line,
          'padding',
          '0'
        );

        important(
          line,
          'position',
          'static'
        );

        important(
          line,
          'white-space',
          'nowrap'
        );

        important(
          line,
          'width',
          'max-content'
        );

        important(
          code,
          'display',
          'inline-block'
        );

        important(
          code,
          'flex',
          '0 0 auto'
        );

        important(
          code,
          'line-height',
          '20px'
        );

        important(
          code,
          'margin',
          '0'
        );

        important(
          code,
          'padding',
          '0'
        );

        important(
          code,
          'position',
          'static'
        );

        important(
          code,
          'white-space',
          'nowrap'
        );

        important(
          code,
          'width',
          'auto'
        );

        important(
          button,
          'align-self',
          'center'
        );

        important(
          button,
          'bottom',
          'auto'
        );

        important(
          button,
          'display',
          'block'
        );

        important(
          button,
          'flex',
          '0 0 20px'
        );

        important(
          button,
          'grid-area',
          'auto'
        );

        important(
          button,
          'height',
          '20px'
        );

        important(
          button,
          'inset',
          'auto'
        );

        important(
          button,
          'left',
          'auto'
        );

        important(
          button,
          'margin',
          '0'
        );

        important(
          button,
          'min-width',
          '20px'
        );

        important(
          button,
          'padding',
          '0'
        );

        important(
          button,
          'position',
          'static'
        );

        important(
          button,
          'right',
          'auto'
        );

        important(
          button,
          'top',
          'auto'
        );

        important(
          button,
          'transform',
          'none'
        );

        important(
          button,
          'width',
          '20px'
        );
      });
  }

  let updateTimer;

  const scheduleUpdate = () => {
    window.clearTimeout(updateTimer);

    updateTimer = window.setTimeout(
      fixCopyIcons,
      80
    );
  };

  new MutationObserver(
    scheduleUpdate
  ).observe(
    document.documentElement,
    {
      childList: true,
      subtree: true
    }
  );

  fixCopyIcons();
})();
(() => {
  'use strict';

  function hideOldHistory() {
    document
      .querySelectorAll(
        '[role="dialog"], [aria-modal="true"]'
      )
      .forEach((modal) => {
        if (
          !/Rewards History/i.test(
            modal.textContent || ''
          )
        ) {
          return;
        }

        if (modal.querySelector('.sacha-rh')) {
          modal.style.removeProperty('opacity');
          modal.style.removeProperty(
            'pointer-events'
          );
        } else {
          modal.style.setProperty(
            'opacity',
            '0',
            'important'
          );

          modal.style.setProperty(
            'pointer-events',
            'none',
            'important'
          );
        }
      });
  }

  new MutationObserver(
    hideOldHistory
  ).observe(
    document.documentElement,
    {
      childList: true,
      subtree: true
    }
  );

  hideOldHistory();
})();
(() => {
  'use strict';

  const CLASS_NAME =
    'sacha-history-desktop-open';

  function visibleHistory() {
    return Array.from(
      document.querySelectorAll(
        '.sacha-rh'
      )
    ).find(
      (element) =>
        element.getClientRects().length > 0
    );
  }

  function updateDesktopScroll() {
    const history = visibleHistory();

    const desktop =
      window.innerWidth >= 750;

    document.documentElement.classList
      .toggle(
        CLASS_NAME,
        Boolean(history && desktop)
      );

    document.body.classList.toggle(
      CLASS_NAME,
      Boolean(history && desktop)
    );

    if (!history || !desktop) return;

    const top =
      history.getBoundingClientRect().top;

    const availableHeight = Math.max(
      240,
      window.innerHeight - top - 20
    );

    history.style.setProperty(
      'max-height',
      `${availableHeight}px`,
      'important'
    );

    history.style.setProperty(
      'overflow-x',
      'hidden',
      'important'
    );

    history.style.setProperty(
      'overflow-y',
      'auto',
      'important'
    );

    history.style.setProperty(
      'overscroll-behavior',
      'contain',
      'important'
    );
  }

  if (
    !document.getElementById(
      'sacha-desktop-scroll-style'
    )
  ) {
    const style =
      document.createElement('style');

    style.id =
      'sacha-desktop-scroll-style';

    style.textContent = `
      @media (min-width: 750px) {
        html.${CLASS_NAME},
        body.${CLASS_NAME} {
          overflow: hidden !important;
          overscroll-behavior: none !important;
        }

        .sacha-rh {
          -webkit-overflow-scrolling:
            touch !important;
          scrollbar-gutter: stable;
        }
      }
    `;

    document.head.appendChild(style);
  }

  let timer;

  function scheduleUpdate() {
    window.clearTimeout(timer);

    timer = window.setTimeout(
      updateDesktopScroll,
      80
    );
  }

  new MutationObserver(
    scheduleUpdate
  ).observe(
    document.documentElement,
    {
      childList: true,
      subtree: true
    }
  );

  window.addEventListener(
    'resize',
    scheduleUpdate
  );

  updateDesktopScroll();
})();